import api from '@/services/api'
import { permissions } from '@/plugins/acl'

export default {
  getGeneral: {
    permission: permissions.generalMetricView,
    request: () => api.get('/general-metrics')
  }
}
